'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (duration, unit) {
    switch (unit) {
        case 's':
            return 1 * duration;
        case 'm':
            return 60 * duration;
        case 'h':
            return 3600 * duration;
        case 'd':
            return 86400 * duration;
        default:
            return undefined;
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/binary-utils/lib/durationToSecs.js
 ** module id = 13
 ** module chunks = 0
 **/